import React from "react";

export function Spinner()
{
    return (
        <div>
            <div className='spinner'></div>
        </div>
    )
}